import React, { useEffect, useState } from "react";
import "../css/main.css";
import "../css/dashboard.css";
import { useNavigate } from "react-router-dom";
import UniversityModal from "../components/UniversityModal";
import UniversityList from "./UniversityList";
import UserList from "./UserList";
import UserModal from "./UserModal";
import {apiRequest, getUniversities, getUsers} from "../api";
import AdminNav from "./AdminNav";
import { isSuperAdmin, isUniAdmin } from "../utils/roleUtils";
import Sidebar from "./Sidebar";

const AdminDashboard = () => {
    const [showModal, setShowModal] = useState(false); // Modal visibility state for universities
    const [refreshList, setRefreshList] = useState(false); // Trigger for re-fetching universities
    const [selectedUniversity, setSelectedUniversity] = useState(null); // Currently selected university

    const [users, setUsers] = useState([]); // State for user list
    const [selectedUser, setSelectedUser] = useState(null); // Currently selected user
    const [showUserModal, setShowUserModal] = useState(false); // Modal visibility state for users
    const [universities, setUniversities] = useState([]); // State for universities
    const apiUrl = process.env.REACT_APP_API_BASE_URL;

    const firstName = localStorage.getItem("firstName"); // Fetch user first name
    const navigate = useNavigate(); // For navigation

    // Logout handler
    const handleLogout = (event) => {
        event.preventDefault();
        console.log("Navigating to /login...");
        localStorage.clear(); // Clear all stored session data
        navigate("/login");
    };

    // Save handler for universities
    const handleSave = () => {
        console.log("University saved. Refreshing list...");
        setShowModal(false);
        setSelectedUniversity(null);
        setRefreshList((prev) => !prev); // Trigger refresh for UniversityList
    };

    // Edit handler for universities
    const handleEdit = (university) => {
        console.log("Editing university:", university);
        setSelectedUniversity(university);
        setShowModal(true);
    };

    // Fetch universities using API
    const fetchUniversities = async () => {
        if (isSuperAdmin()) {
            try {
                const universities = await getUniversities(); // Call API
                setUniversities(universities);
            } catch (error) {
                console.error("Error fetching universities:", error);
                setUniversities([]); // Default to empty array on error
            }
        }
    };


    // Run on component mount and when refreshList changes
    useEffect(() => {
        fetchUniversities();
    }, [refreshList]); // Re-fetch universities when refreshList toggles

    // Add user handler
    const handleAddUser = () => {
        setSelectedUser(null); // Clear user selection for adding new user
        setShowUserModal(true);
    };

    // Edit user handler
    const handleEditUser = (user) => {
        setSelectedUser(user); // Set user for editing
        setShowUserModal(true);
    };

    // Save user handler
    const handleSaveUser = async () => {
        setShowUserModal(false); // Close modal after saving
        const token = localStorage.getItem("token"); // Get token from local storage

        try {
            const endpoint = `${apiUrl}/users`; // API endpoint for users
            const users = await apiRequest(endpoint, "GET", null, token); // Fetch users
            setUsers(users); // Update state with fetched users
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };

    return (
        <div className="dashboard">
            <Sidebar />
            <main className="main-content">
                <header className="header">
                    <h3>Welcome back, {firstName}!</h3>
                    <h4>Overview</h4>
                    <hr />
                    <div className="overview">
                        <div className="overview-item"><h2>12</h2><p>Tours</p></div>
                        <div className="overview-item"><h2>45</h2><p>Events</p></div>
                        <div className="overview-item"><h2>1,223</h2><p>Submissions</p></div>
                    </div>
                </header>

                <section className="quick-actions">
                    <h4>Quick Actions</h4>
                    <hr />
                    <div className="actions">
                        {isSuperAdmin() && (
                            <button onClick={() => setShowModal(true)} className="action-button new-tour">
                                <i className="fa fa-school" aria-hidden="true"></i> + New University
                            </button>
                        )}
                        <button onClick={handleAddUser} className="action-button new-event">
                            <i className="fa fa-user" aria-hidden="true"></i> + New User
                        </button>
                        <a href="/new-form" className="action-button new-form">
                            <i className="fa fa-sticky-note" aria-hidden="true"></i> + New Form Template
                        </a>
                    </div>
                </section>
                {isSuperAdmin() && (
                    <>
                        <h4>Universities</h4>
                        <UniversityList onEdit={handleEdit} refreshList={refreshList} />
                    </>
                )}
                <h4>Users</h4>
                <UserList users={users} onEdit={handleEditUser} />

                {showModal && (
                    <UniversityModal
                        university={selectedUniversity}
                        onClose={() => setShowModal(false)}
                        onSave={handleSave}
                    />
                )}

                {showUserModal && (
                    <UserModal
                        user={selectedUser}
                        universities={universities}
                        onClose={() => setShowUserModal(false)}
                        onSave={handleSaveUser}
                    />
                )}
            </main>
        </div>
    );
};

export default AdminDashboard;